import { createSelector } from '@ngrx/store';

import { getUserLanguage } from '../../../shared/store/selectors/user-env';
import { DeviceMS } from '../../models/Device';
import { sortDeviceMS } from '../../utils/devices';
import { DeviceListItemVm } from '../view-models/deviceListItemVm';

import { getSelectedSiteDevices } from './devices';
import { getSelectedGatewayId } from './gateways';

function isHub(device: DeviceMS): boolean {
    return device.categories.includes('hub');
}

const getSelectedGatewayDevices = createSelector(getSelectedSiteDevices, getSelectedGatewayId, (devices, gatewayId) =>
    devices.filter((device) => device.deviceurl?.includes(gatewayId) && !isHub(device)),
);

export const getDeviceItemList = createSelector(
    getSelectedGatewayDevices,
    getUserLanguage,
    (devices, language): DeviceListItemVm[] =>
        [...devices]
            .sort((a, b) => sortDeviceMS(a, b, language))
            .map((device) => ({
                deviceId: device.id,
                deviceName: device.name,
                icon: device.icon,
                profileName: device.product_profile || device.protocol_profile,
            })),
);
